import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  BANK_STATEMENT,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchBankStatement = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_BANK_STATEMENT}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_BANK_STATEMENT}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_BANK_STATEMENT}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_BANK_STATEMENT}${query}${sorting}`);
};

const postBankStatement = async (params) => axiosAuthInstance.post(API_END_POINTS.GET_BANK_STATEMENT, params);

export function* getBankStatement(action) {
  try {
    const { data: { entity } } = yield call(fetchBankStatement, action.payload);
    yield put({ type: BANK_STATEMENT.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: BANK_STATEMENT.FAILED, payload: e.response.data });
  }
}

export function* addBankStatement(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postBankStatement, action.payload);
    const { data: { entity } } = yield call(fetchBankStatement, action.payload);
    yield put({ type: BANK_STATEMENT.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.OCRREQUEST.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
